enum ApplicationInstanceEventType  {
  Unspecified = 0,
  Physical = 1,
  Virtual = 2,
  Hybrid = 3,
}
export default Object.freeze(ApplicationInstanceEventType);
